import {auth} from '@/services/auth';
import router from '../../router/index';
import {commonService} from "@/services/common";
import VueCookies from "vue-cookies";

export const state = {
  currentUser: sessionStorage.getItem('user'),
  loading: false,
  exists: false,
  distributor: '',
  currencyType: 'VND'
};


export const mutations = {

  loginRequest(state) {
    state.loading = true;
  },
  loginSuccess(state, user) {
    state.loading = false;
    state.currentUser = user.user_info;
  },
  loginFailure(state) {
    state.loading = false;
    state.exists = true;
  },
  logout(state) {
    state.status = {};
    state.currentUser = null;
  },
  registerRequest(state) {
    state.loading = true;
    state.exists = false;
  },
  registerSuccess(state) {
    state.loading = false;
    state.exists = false;
  },
  registerFailure(state) {
    state.loading = false;
    state.exists = true;
  },
  getMe(state) {
    state.loading = true;
  },
  getMeSuccess(state) {
    state.loading = false;
  },
  getMeFail(state) {
    state.loading = false;
  },

  setDistributorInfo(state, data) {
    state.distributor = data
  },

  setCurrentType(state, data){
    state.currencyType = data||'VND'
  }
};

export const actions = {

  // Login the user.
  logIn({dispatch, commit}, {email, password, isSaveLogin}) {
    commit('loginRequest', {email});
    auth.login(email, password)
      .then(async response => {
          if (response.data.error) {
            console.log(response.data);
            commit('loginFailure', response.data.error.message);
            dispatch(
              'notification/error',
              response.data.error.code === 500 ? `${response.data.error.code} - ${response.data.error.message}` : response.data.error.message,
              {root: true}
            );
          } else {
            const userData = response.data.data;
            const roleId = userData.list_role[0].role_id;
            if (roleId) {
              commit('loginSuccess', response.data);
              if (userData.token) {
                // xoá storage + cookie của user đăng nhập nếu đã tồn tại
                localStorage.removeItem(userData.id);
                VueCookies.remove(userData.id);
                if (isSaveLogin) {
                  // ghi nhớ đăng nhập
                  VueCookies.set('token', `${userData.token}-${new Date().getTime()}`, "7d");
                } else {
                  // không ghi nhớ đăng nhập
                  VueCookies.set('token', userData.token, "7d");
                }
                delete userData.token;
                localStorage.setItem('user', JSON.stringify(userData));
              }
              await commonService.registerFirebase(
                {
                  "device_type": "WEB",
                  "registration_id": localStorage.getItem('fTk')
                }
              );
              switch (roleId) {
                case 'DEBT_ACCOUNTANT':
                  router.push('/sell');
                  break;
                case 'TELESALES':
                  router.push('/order/wait');
                  break;
                default:
                  router.push('/');
                  break;
              }
            } else {
              // nếu muốn chặn role nào đó đăng nhập trên web
              commit('loginFailure', 'Vui lòng đăng nhập ứng dụng IDS trên iOS hoặc Android');
              dispatch('notification/error', 'Vui lòng đăng nhập ứng dụng HRM trên iOS hoặc Android', {root: true});
            }
          }
        },
        error => {
          commit('loginFailure', error);
          dispatch('notification/error', error, {root: true});
        }
      );
  },

  // Login the user.
  addSessionLogin({dispatch, commit}, {email, password}) {
    commit('loginRequest', {email});
    auth.login(email, password)
      .then(async response => {
          if (response.data.error) {
            commit('loginFailure', response.data.error.message);
            dispatch(
              'notification/error',
              response.data.error.code === 500 ? `${response.data.error.code} - ${response.data.error.message}` : response.data.error.message,
              {root: true}
            );
          } else {
            const userData = response.data.data;
            const roleId = userData.list_role[0].role_id;
            if (roleId) {
              commit('loginSuccess', response.data);
              if (userData.token) {
                const oldToken = VueCookies.get('token');
                const oldUser = localStorage.getItem('user');
                const oldUserData = JSON.parse(oldUser);
                if (oldToken&&oldToken.indexOf('-') > 0) {
                  // có lưu lại token
                  localStorage.setItem(oldUserData.id, oldUser);
                  VueCookies.set(oldUserData.id, oldToken, '7d');
                }

                if (oldUserData.id === userData.id) {
                  localStorage.removeItem(userData.id);
                  VueCookies.remove(userData.id);
                }
                localStorage.setItem('user', JSON.stringify(userData));
                VueCookies.set('token', `${userData.token}-${new Date().getTime()}`, "7d");
              }
              await commonService.registerFirebase(
                {
                  "device_type": "WEB",
                  "registration_id": localStorage.getItem('fTk')
                }
              );
              switch (roleId) {
                case 'DEBT_ACCOUNTANT':
                  router.push('/sell');
                  break;
                case 'TELESALES':
                  router.push('/order/wait');
                  break;
                default:
                  router.push('/');
                  break;
              }
            } else {
              // nếu muốn chặn role nào đó đăng nhập trên web
              commit('loginFailure', 'Vui lòng đăng nhập ứng dụng IDS trên iOS hoặc Android');
              dispatch('notification/error', 'Vui lòng đăng nhập ứng dụng HRM trên iOS hoặc Android', {root: true});
            }
          }
        },
        error => {
          commit('loginFailure', error);
          dispatch('notification/error', error, {root: true});
        }
      );
  },

  // get Me.
  me({dispatch, commit}) {
    commit('getMe');
    auth.me()
      .then(response => {
          if (response.data.error) {
            commit('getMeFail', response.data.error.message);
            dispatch(
              'notification/error',
              response.data.error.code === 500 ? `${response.data.error.code} - ${response.data.error.message}` : response.data.error.message,
              {root: true}
            );
          } else {
            commit('getMeSuccess', response.data);
            if (response.data) {
              localStorage.setItem('user', JSON.stringify(response.data.data));
            }
          }
        },
        error => {
          commit('loginFailure', error);
          dispatch('notification/error', error, {root: true});
        }
      );
  },

  // Logout the user
  logOut({commit}) {
    auth.logout();
    commit('logout');
  },

  // Register the user
  register({dispatch, commit}, user) {
    commit('registerRequest', user);
    auth.register(user).then(
      response => {
        if (response.error) {
          commit('registerFailure', response.error.message);
          dispatch('notification/error', response.error.message, {root: true});
        } else {
          commit('registerSuccess');
          dispatch('notification/success', 'Đăng ký thành công', {root: true});
          router.push('/login');
        }
      },
      error => {
        commit('registerFailure', error);
        dispatch('notification/error', error, {root: true});
      }
    );
  },

  setDistributor({commit}, data){
    commit('setCurrentType', data)
  },

  getDistributor({commit}, id){
    if(id){
      commonService.getDistributorInfo({uid: id}).then(response=>{
        if(response && response.data && response.data.data){
          const {extra_data} = response.data.data
          commit('setDistributorInfo', response.data.data)
          commit('setCurrentType', extra_data&&extra_data.currency_type)
        }
      })
    }
  }
};

